import { TimeZone } from "@relode/core/domain";
import { dashboards } from "../../../../shared/backend/controllers";
export class MemberUpcomingInterview {
    public constructor(
        public leadId: number,
        public jobId: number,
        public jobName: string,
        public organization: string,
        public candidateName: string,
        public location: string,
        public interviewDate: string,
        public interviewTimeSpan: string
    ) {}
}

export const convertCandidateInterviewResponses = (
    res: dashboards.CandidateInterviewResponse[]
) => {
    if (!res) return null;

    const result = res
        .filter(i => !!i)
        .map(i => {
            const interval = `${[i.interviewStartTime, i.interviewEndTime].join(
                " - "
            )} ${TimeZone.fromId(i.timeZoneId).abbreviation}`;
            return new MemberUpcomingInterview(
                i.leadId,
                i.jobId,
                i.jobName,
                i.teamName,
                i.fullName,
                i.locationName,
                i.interviewDate,
                interval
            );
        });

    return result;
};
